import { render } from "./Homepage.vue?vue&type=template&id=08a2b078&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=08a2b078&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ken\\Documents\\GitHub\\KasongNursingHome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a2b078"]])

export default __exports__